(function () {
  if (window.__cartUpsellControllerLoaded) {
    return;
  }

  window.__cartUpsellControllerLoaded = true;

  const selectors = {
    wrapper: '.cart-drawer_upsell',
    track: '[data-upsell-track]',
    row: '.upsell-row',
    addButton: '.upsell-add',
    navButton: '.upsell-nav-btn'
  };

  const edgeTolerance = 3;

  let activeDragTrack = null;
  let dragStartX = 0;
  let dragInitialScroll = 0;
  let dragHasMoved = false;
  let updateFrame = null;

  function getClosestElement(target, selector) {
    if (!(target instanceof Element)) {
      return null;
    }

    return target.closest(selector);
  }

  function getCartDrawer(element) {
    const closestDrawer = element.closest('cart-drawer');

    if (closestDrawer) {
      return closestDrawer;
    }

    const drawers = Array.from(
      document.querySelectorAll('cart-drawer')
    );

    const visibleDrawer = drawers.find(function (drawer) {
      const styles = window.getComputedStyle(drawer);

      return (
        styles.display !== 'none' &&
        styles.visibility !== 'hidden'
      );
    });

    return visibleDrawer || drawers[0] || null;
  }

  function setButtonLoading(button, loading) {
    if (!button) {
      return;
    }

    button.disabled = loading;
    button.classList.toggle('is-loading', loading);

    if (loading) {
      button.dataset.loading = 'true';
      button.setAttribute('aria-busy', 'true');
    } else {
      delete button.dataset.loading;
      button.removeAttribute('aria-busy');
    }
  }

  function unlockAllButtons() {
    document
      .querySelectorAll(selectors.addButton)
      .forEach(function (button) {
        setButtonLoading(button, false);
      });
  }

  function getMaximumScroll(track) {
    return Math.max(
      0,
      track.scrollWidth - track.clientWidth
    );
  }

  function getCurrentScroll(track) {
    const maximumScroll = getMaximumScroll(track);

    return Math.min(
      Math.max(0, track.scrollLeft),
      maximumScroll
    );
  }

  function updateNavigation(wrapper) {
    if (!wrapper || !wrapper.isConnected) {
      return;
    }

    const track = wrapper.querySelector(selectors.track);

    const previousButton = wrapper.querySelector(
      selectors.navButton + '[data-dir="prev"]'
    );

    const nextButton = wrapper.querySelector(
      selectors.navButton + '[data-dir="next"]'
    );

    if (!track || !previousButton || !nextButton) {
      return;
    }

    const maximumScroll = getMaximumScroll(track);
    const currentScroll = getCurrentScroll(track);

    previousButton.disabled =
      currentScroll <= edgeTolerance;

    nextButton.disabled =
      maximumScroll <= edgeTolerance ||
      currentScroll >= maximumScroll - edgeTolerance;
  }

  function updateAllNavigation() {
    document
      .querySelectorAll(selectors.wrapper)
      .forEach(updateNavigation);
  }

  function scheduleNavigationUpdate() {
    if (updateFrame) {
      window.cancelAnimationFrame(updateFrame);
    }

    updateFrame = window.requestAnimationFrame(function () {
      updateFrame = null;
      updateAllNavigation();
    });
  }

  function scrollByOneCard(button) {
    const wrapper = button.closest(selectors.wrapper);

    if (!wrapper) {
      return;
    }

    const track = wrapper.querySelector(selectors.track);
    const card = track
      ? track.querySelector(selectors.row)
      : null;

    if (!track || !card) {
      return;
    }

    const trackStyle = window.getComputedStyle(track);
    const gap = parseFloat(trackStyle.gap) || 12;
    const distance = card.offsetWidth + gap;

    const maximumScroll = getMaximumScroll(track);
    const currentScroll = getCurrentScroll(track);

    const destination =
      button.dataset.dir === 'next'
        ? Math.min(currentScroll + distance, maximumScroll)
        : Math.max(currentScroll - distance, 0);

    track.scrollTo({
      left: destination,
      behavior: 'smooth'
    });

    window.setTimeout(function () {
      updateNavigation(wrapper);
    }, 350);
  }

  async function addUpsellProduct(button) {
    if (
      !button ||
      button.disabled ||
      button.dataset.loading === 'true'
    ) {
      return;
    }

    const variantId = Number(button.dataset.variantId);

    if (!variantId) {
      console.error(
        'Upsell: data-variant-id não encontrado.'
      );
      return;
    }

    const drawer = getCartDrawer(button);

    if (!drawer) {
      console.error(
        'Upsell: cart-drawer não encontrado.'
      );
      return;
    }

    setButtonLoading(button, true);

    const controller = new AbortController();

    const timeoutId = window.setTimeout(function () {
      controller.abort();
    }, 12000);

    try {
      let sections = [];

      if (
        typeof drawer.getSectionsToRender === 'function'
      ) {
        sections = drawer
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .filter(Boolean);
      }

      const requestBody = {
        id: variantId,
        quantity: 1
      };

      if (sections.length > 0) {
        requestBody.sections = sections;
        requestBody.sections_url =
          window.location.pathname;
      }

      const cartAddUrl =
        window.routes &&
        window.routes.cart_add_url
          ? window.routes.cart_add_url
          : '/cart/add.js';

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(requestBody),
        signal: controller.signal,
        cache: 'no-store'
      });

      const responseText = await response.text();

      let data = {};

      try {
        data = responseText
          ? JSON.parse(responseText)
          : {};
      } catch (error) {
        throw new Error(
          'O carrinho retornou uma resposta inválida.'
        );
      }

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          'Não foi possível adicionar o produto.'
        );
      }

      if (
        data.sections &&
        typeof drawer.renderContents === 'function'
      ) {
        drawer.renderContents(data);
      } else {
        document.dispatchEvent(
          new CustomEvent('cart:refresh')
        );
      }

      window.requestAnimationFrame(function () {
        unlockAllButtons();
        scheduleNavigationUpdate();
      });
    } catch (error) {
      if (error.name === 'AbortError') {
        console.error(
          'Upsell: a requisição excedeu 12 segundos.'
        );
      } else {
        console.error(
          'Upsell: erro ao adicionar produto:',
          error
        );
      }
    } finally {
      window.clearTimeout(timeoutId);

      if (button && button.isConnected) {
        setButtonLoading(button, false);
      }

      unlockAllButtons();
      scheduleNavigationUpdate();
    }
  }

  /*
    Clique delegado: continua funcionando mesmo depois
    que o cart drawer substitui todo o HTML interno.
  */
  document.addEventListener(
    'click',
    function (event) {
      const addButton = getClosestElement(
        event.target,
        selectors.addButton
      );

      if (addButton) {
        event.preventDefault();
        event.stopPropagation();

        addUpsellProduct(addButton);
        return;
      }

      const navButton = getClosestElement(
        event.target,
        selectors.navButton
      );

      if (!navButton || navButton.disabled) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      scrollByOneCard(navButton);
    },
    true
  );

  /*
    Arraste desktop usando eventos globais.
    Não depende dos elementos antigos do drawer.
  */
  document.addEventListener(
    'mousedown',
    function (event) {
      const track = getClosestElement(
        event.target,
        selectors.track
      );

      if (!track) {
        return;
      }

      if (
        getClosestElement(
          event.target,
          'button, a, input, select, textarea'
        )
      ) {
        return;
      }

      activeDragTrack = track;
      dragStartX = event.clientX;
      dragInitialScroll = track.scrollLeft;
      dragHasMoved = false;

      track.classList.add('is-dragging');
    },
    true
  );

  document.addEventListener(
    'mousemove',
    function (event) {
      if (!activeDragTrack) {
        return;
      }

      const distance = event.clientX - dragStartX;

      if (
        !dragHasMoved &&
        Math.abs(distance) < 4
      ) {
        return;
      }

      dragHasMoved = true;
      event.preventDefault();

      activeDragTrack.scrollLeft =
        dragInitialScroll - distance * 1.2;
    },
    {
      capture: true,
      passive: false
    }
  );

  function finishDragging() {
    if (!activeDragTrack) {
      return;
    }

    activeDragTrack.classList.remove(
      'is-dragging'
    );

    activeDragTrack = null;
    dragHasMoved = false;

    scheduleNavigationUpdate();
  }

  document.addEventListener(
    'mouseup',
    finishDragging,
    true
  );

  window.addEventListener(
    'blur',
    finishDragging
  );

  /*
    O evento scroll é capturado globalmente para funcionar
    também nos trilhos criados após uma atualização.
  */
  document.addEventListener(
    'scroll',
    function (event) {
      const track = getClosestElement(
        event.target,
        selectors.track
      );

      if (!track) {
        return;
      }

      const wrapper = track.closest(
        selectors.wrapper
      );

      if (wrapper) {
        scheduleNavigationUpdate();
      }
    },
    true
  );

  /*
    Recalcula as setas sempre que o cart drawer
    substituir produtos ou blocos.
  */
  const observer = new MutationObserver(function () {
    unlockAllButtons();
    scheduleNavigationUpdate();
  });

  function startController() {
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    unlockAllButtons();
    scheduleNavigationUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startController,
      {
        once: true
      }
    );
  } else {
    startController();
  }

  window.addEventListener(
    'resize',
    scheduleNavigationUpdate
  );

  document.addEventListener(
    'cart:refresh',
    function () {
      unlockAllButtons();
      scheduleNavigationUpdate();
    }
  );
})();